import request from '@/utils/request'
// const baseUrl = `https://wx.17u.cn/membercenterwechatv2/standardcard/app`

// 获取实名认证数据
export const getAuthData = (data) => {
    return request({
        url: `${process.env.VUE_APP_BASE_URL}/backendActivity/common/getRealName`,
        method: 'post',
        headers: Object.assign({
            'Content-Type': 'application/json; charset=UTF-8'
        }, data.headers),
        data: data.params
    })
}

// 获取学校数据
export const getschoolData = (data) => {
    return request({
        url: `${process.env.VUE_APP_BASE_WX_URL}/youngcardnew/getschoolname?Labrador-Token=126d9426-4282-4530-a730-61b090ea319e&Labrador-Passthrough=true`,
        method: 'post',
        headers: Object.assign({
            'Content-Type': 'application/json; charset=UTF-8',
            'platForm': '1'
        }, data.headers),
        data: data.params
    })
}

// 发送验证码
export const sendVerifyCodeApi = (data) => {
    return request({
        url: `${process.env.VUE_APP_BASE_URL}/backendActivity/common/sendVerifyCode`,
        method: 'post',
        headers: Object.assign({
            'Content-Type': 'application/json; charset=UTF-8'
        }, data.headers),
        data: data.params
    })
}

// 上传图片
// export const uploadImgApi = (data) => {
//     return request({
//         url: `${process.env.VUE_APP_BASE_URL}/paymentdoctor/uploadimage`,
//         method: 'post',
//         headers: Object.assign({
//             'Content-Type': 'application/json; charset=UTF-8'
//         }, data.headers),
//         data: data.params
//     })
// }

//提交认证
export const submitAuth = (data) => {
    return request({
      url: `${process.env.VUE_APP_BASE_URL}/backendActivity/student/auth`,
      method: 'post',
      headers: Object.assign({
          'Content-Type': 'application/json; charset=UTF-8',
      }, data.headers),
      data: data.params
    })
}

